module.exports = __webpack_public_path__ + "media/images/icons/country_flags/es-pv-bc671336343cce95f7941645285b8282.svg";